import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface TorsionBarProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function TorsionBar(props: TorsionBarProps) {
  return (
    <svg
      width="63"
      height="229"
      viewBox="0 0 63 229"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 137, right: 213}}
      onClick={props.onClick}
    >
      <path
        d="M47.0481 178.844C55.0481 170.864 55.3258 170.484 55.3258 163.5V114.5V65.5005C55.3258 58.5174 55.0481 58.1371 47.0481 50.1565C40.6592 43.783 16.4752 19.752 1.32593 6.04071L4.51196 1.50046C19.2783 14.8471 46.2466 41.3763 53.0479 48.1612C61.0479 56.1419 61.3258 56.5174 61.3258 63.5005V114.5V165.5C61.3258 172.484 61.0479 172.859 53.0479 180.84C46.2466 187.625 19.2783 214.154 4.51196 227.5L1.32593 222.96C16.4752 209.249 40.6592 185.218 47.0481 178.844Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      />
      <path
        d="M47.0481 178.844C55.0481 170.864 55.3258 170.484 55.3258 163.5V114.5V65.5005C55.3258 58.5174 55.0481 58.1371 47.0481 50.1565C40.6592 43.783 16.4752 19.752 1.32593 6.04071L4.51196 1.50046C19.2783 14.8471 46.2466 41.3763 53.0479 48.1612C61.0479 56.1419 61.3258 56.5174 61.3258 63.5005V114.5V165.5C61.3258 172.484 61.0479 172.859 53.0479 180.84C46.2466 187.625 19.2783 214.154 4.51196 227.5L1.32593 222.96C16.4752 209.249 40.6592 185.218 47.0481 178.844Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
    </svg>
  );
}
